const get_started = {
    page_title: 'Rozpocznij',
    title: 'Coś do odkrycia, aby pomóc ci odnieść sukces',
    subtitle: 'Kilka rzeczy, które możesz zrobić, aby szybko uzyskać wartość Logto',
    develop: {
        title: 'Develop: Zajmie to 5 minut, aby zintegrować swoją aplikację',
        title_cloud: 'Develop: Bezpiecznie zintegruj swoją aplikację w kilka minut',
        subtitle_cloud: 'Lub poświęć 5 minut na integrację swojej aplikacji za pomocą naszych gotowych SDKów i samouczków.',
        try_mcp: 'Wypróbuj integrację jednym poleceniem z MCP',
    },
    customize: {
        title: 'Customize: Dostarcz świetne doświadczenie logowania',
        preview: {
            title: 'Sprawdź podgląd na żywo doświadczenia logowania, które właśnie spersonalizowałeś',
            subtitle: 'Wypróbuj teraz Logto, aby zobaczyć, jak działa',
        },
        connector: {
            title: 'Dodaj więcej konektorów, aby obsługiwać różne metody logowania społecznego',
            subtitle: 'Wypróbuj logowanie bez hasła i włącz bezpieczne i bezproblemowe doświadczenie dla swoich klientów',
        },
        continue_customizing: 'Kontynuuj dostosowywanie',
        try_now: 'Wypróbuj teraz',
        add_more: 'Dodaj więcej',
    },
    secure: {
        title: 'Zabezpiecz: Chron swoje zasoby',
    },
    manage: {
        title: 'Zarządzaj: Określ kontrolę dostępu do swojego produktu i użytkowników',
        rbac: {
            title: 'Dodaj oparte na rolach zarządzanie dostępem, aby chronić swoje zasoby',
            subtitle: 'Kontroluj swoje zasoby za pomocą skalowalnej autoryzacji opartej na rolach dla różnych przypadków użycia',
        },
        create_roles: 'Twórz role',
    },
    convert_to_production: {
        card_title: 'Gotowy do uruchomienia? Nie zapomnij rozpocząć konfiguracji produkcyjnej!',
        title: 'Nie utrzymuj swojego projektu w trybie deweloperskim',
        subtitle: 'Używasz dzierżawy deweloperskiej do darmowych testów. Aby uruchomić produkcję, utwórz nową lub przekształć aktualną w dzierżawę produkcyjną. Potrzebujesz czegoś niestandardowego? <a>Skontaktuj się z nami</a>',
        convert_button: 'Przekształć w dzierżawę produkcyjną',
    },
    oss_cloud: {
        try: {
            title: 'Pomiń pracę operacyjną i wypróbuj Logto Cloud za darmo',
            badge: 'Polecane',
            description: 'Otrzymaj w pełni zarządzane Logto bez konieczności utrzymania, a także szybkie wdrożenie z MCP, obsługę wielu tenantów, współpracę zespołową i wszystkie funkcje premium w pakiecie. Zacznij za darmo, bez karty kredytowej.',
            action: 'Poznaj Logto Cloud',
        },
        private_cloud: {
            title: 'Potrzebujesz zgodności lub niestandardowego wdrożenia?',
            card_title: 'Chmura prywatna',
            description: 'Uzyskaj dedykowaną instancję Logto z pełną izolacją danych, własną domeną i gwarancjami SLA. To idealne rozwiązanie dla firm z rygorystycznymi wymaganiami dotyczącymi rezydencji danych lub zgodności. My zajmiemy się infrastrukturą, abyś mógł skupić się na swoim produkcie.',
        },
        sidebar: {
            title: 'Skup się na budowaniu, nie na hostowaniu.',
            description: 'Pozwól, aby Logto Cloud zajęło się za Ciebie infrastrukturą uwierzytelniania.',
            action: 'Wypróbuj Logto Cloud',
        },
    },
    view_all: 'Zobacz wszystkie →',
};
export default Object.freeze(get_started);
